/**
 * StickerRestoreReq 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * StickerRestoreReq
 */
export interface StickerRestoreReq {
  /** 表情包ID */
  id: string
}

/**
 * StickerRestoreReq Schema
 */
export const StickerRestoreReqSchema: SchemaDefinition = {
  properties: {
    id: {
      description: '表情包ID',
      format: 'string',
      type: 'string',
      label: '表情包ID',
    },
  },
  required: ['id'],
  type: 'object',
}
